import(/* webpackMode: "eager" */ "/vercel/path0/app/[lng]/terms/page.tsx");
